import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type HealthStatus = "unknown" | "ok" | "degraded" | "unreachable";

export interface AppHealth {
  id: string;
  status: HealthStatus;
  checkedAt: string | null;
  failingSince: string | null;
}

/** `null` for an app means "not reporting" — never "no access". */
export type AccessAnswer = {
  registered: boolean;
  role: string | null;
  suspended: boolean;
} | null;

export function useAppHealth() {
  return useQuery({
    queryKey: ["directory", "health"],
    queryFn: () =>
      api.get<{ configured: boolean; health: AppHealth[] }>("/directory/health"),
    // Served from the poller's cache, so this is cheap; a launcher does not
    // need second-level accuracy.
    refetchInterval: 120_000,
  });
}

export function useAppAccess() {
  return useQuery({
    queryKey: ["directory", "access"],
    queryFn: () =>
      api.get<{
        configured: boolean;
        access: Record<string, AccessAnswer>;
      }>("/directory/access"),
    staleTime: 60_000,
  });
}

export interface MatrixApp {
  appId: string;
  slug: string;
  title: string;
  roster: Array<{
    email: string;
    role: string | null;
    deactivated: boolean;
    lastSeenAt: string | null;
  }> | null;
}

export function useAccessMatrix() {
  return useQuery({
    queryKey: ["directory", "matrix"],
    queryFn: () =>
      api.get<{ configured: boolean; apps: MatrixApp[]; emails: string[] }>(
        "/directory/matrix",
      ),
  });
}
